import { PATTERN_REGISTRY_ERRORS } from '../../constants/ErrorConstants';
import { InputElementModel, InputModel } from '../services/InputElementModel';
import { IPatternRegistryValidationModel } from './IPatternRegistryValidationModel';

const patternRegistryName: InputElementModel = {
  name: 'patternRegistryName',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidPatternRegistryName,
  expression: /^[a-zA-Z](-*[a-zA-Z0-9])*$/,
  isValid: true,
  isTouched: false
};

const eventName: InputElementModel = {
  name: 'eventName',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidEventName,
  expression: /^[A-Z0-9.-]+$/,
  isValid: true,
  isTouched: false
};

const occurrences: InputElementModel = {
  name: 'occurrences',
  value: '1',
  error: PATTERN_REGISTRY_ERRORS.invalidOccurrences,
  expression: /^[1-9]\d*$/,
  isValid: true,
  isTouched: false
};

const timeToLive: InputElementModel = {
  name: 'timeToLive',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidTimeToLive,
  expression: /^[1-9]\d*$/,
  isValid: true,
  isTouched: false
};

const uniqueId: InputElementModel = {
  name: 'uniqueId',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidUniqueId,
  expression: /^[^ ]*$/,
  isValid: true,
  isTouched: false
};

const fieldDefName: InputElementModel = {
  name: 'fieldDefName',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidFDName,
  expression: /^\d*[a-zA-Z.][a-zA-Z\d.]*$$/,
  isValid: true,
  isTouched: false
};

const fieldDefOperator: InputElementModel = {
  name: 'fieldDefOperator',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidPatternType,
  expression: /^[a-zA-Z0-9-_\s(.+)]+$/,
  isValid: true,
  isTouched: false
};

const fieldDefValue: InputElementModel = {
  name: 'fieldDefValue',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidFDValue,
  expression: /^(?!\s*$).+/,
  isValid: true,
  isTouched: false
};

const fieldDefConversionPattern: InputElementModel = {
  name: 'fieldDefConversionPattern',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidFDValue,
  expression: /^(?!\s*$).+/,
  isValid: true,
  isTouched: false
};

const fieldDefIsRequired: InputModel = {
  name: 'fieldDefIsRequired',
  value: false,
  error: PATTERN_REGISTRY_ERRORS.invalidFDValue,
  expression: /^(?!\s*$).+/,
  isValid: true,
  isTouched: false
};

const fieldDefContentType: InputElementModel = {
  name: 'fieldDefContentType',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidPatternType,
  expression: /^[a-zA-Z0-9-_\s(.+)]+$/,
  isValid: true,
  isTouched: false
};

const fieldCondition: InputElementModel = {
  name: 'fieldCondition',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidPatternType,
  expression: /^[a-zA-Z0-9-_\s(.+)]+$/,
  isValid: true,
  isTouched: false
};

const fieldN: InputElementModel = {
  name: 'fieldN',
  value: '',
  error: PATTERN_REGISTRY_ERRORS.invalidFieldN,
  expression: /^[1-9]\d*$/,
  isValid: true,
  isTouched: false
};

export class PatternRegistryFormData implements IPatternRegistryValidationModel {
  patternRegistryName: InputElementModel;

  eventName: InputElementModel;

  occurrences: InputElementModel;

  timeToLive: InputElementModel;

  uniqueId: InputElementModel;

  fieldDefName: InputElementModel;

  fieldDefOperator: InputElementModel;

  fieldDefValue: InputElementModel;

  fieldDefContentType: InputElementModel;

  fieldCondition: InputElementModel;

  fieldN: InputElementModel;

  fieldDefConversionPattern: InputElementModel;

  fieldDefIsRequired: InputModel;

  constructor() {
    this.patternRegistryName = patternRegistryName;
    this.eventName = eventName;
    this.occurrences = occurrences;
    this.timeToLive = timeToLive;
    this.uniqueId = uniqueId;
    this.fieldDefName = fieldDefName;
    this.fieldDefOperator = fieldDefOperator;
    this.fieldDefValue = fieldDefValue;
    this.fieldDefContentType = fieldDefContentType;
    this.fieldCondition = fieldCondition;
    this.fieldN = fieldN;
    this.fieldDefConversionPattern = fieldDefConversionPattern;
    this.fieldDefIsRequired = fieldDefIsRequired;
  }
}
